import { useMemo } from 'react'

import { Link } from 'react-router-dom'

import LarkThemeLogo from '@/assets/images/text-logo-black.svg'
import DarkThemeLogo from '@/assets/images/text-logo-white.svg'
import { AppRoutes } from '@/utils/constants'
import { useIsDarkTheme } from '@/utils/useTheme'

interface Props {
  width?: number
  height?: number
  useLink?: boolean
}

export const CreatorHeroLogo = ({ width, height, useLink = true }: Props) => {
  const isDark = useIsDarkTheme()

  const imageProps = useMemo(
    () => ({
      width,
      height,
      alt: 'CreatorHero Logo',
    }),
    [height, width],
  )

  const logo = isDark ? (
    <DarkThemeLogo {...imageProps} />
  ) : (
    <LarkThemeLogo {...imageProps} />
  )

  return useLink ? <Link to={AppRoutes.Overview.asUrl()}>{logo}</Link> : logo
}
